import { render, staticRenderFns } from "./ColumnWithIcon.vue?vue&type=template&id=346259de&scoped=true&"
import script from "./ColumnWithIcon.vue?vue&type=script&lang=ts&"
export * from "./ColumnWithIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnWithIcon.vue?vue&type=style&index=0&id=346259de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346259de",
  null
  
)

export default component.exports